/* Adele Chérie — Collection 2026 v2 JS
   - Drawer mobile filtri (open/close + ESC + overlay)
   - AJAX live filters via Section Rendering API (?section_id=)
   - Sidebar + grid + count update senza reload
   - URL sync via history.replaceState
   - Filter search (brand / list lunghe)
   - Debounced submit on change
*/
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getSection() { return $('.ac-coll'); }
  function getSectionId(section) { return section && section.getAttribute('data-section-id'); }

  /* ============ Drawer mobile ============ */
  function initDrawer(section) {
    var sidebar = $('[data-ac-filter-panel]', section);
    var openBtn = $('[data-ac-filter-open]', section);
    var closeBtns = $$('[data-ac-filter-close]', section);
    if (!sidebar) return;

    var open = function () { sidebar.classList.add('is-open'); document.body.classList.add('has-ac-filter-open'); };
    var close = function () { sidebar.classList.remove('is-open'); document.body.classList.remove('has-ac-filter-open'); };

    if (openBtn) openBtn.addEventListener('click', open);
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });

    document.addEventListener('click', function (e) {
      if (!sidebar.classList.contains('is-open')) return;
      if (sidebar.contains(e.target)) return;
      if (openBtn && (e.target === openBtn || openBtn.contains(e.target))) return;
      if (e.target === document.body || e.target.matches('body::before')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) close();
    });
  }

  /* ============ Filter internal search (brand / lunghe) ============ */
  function initFilterSearch(section) {
    $$('[data-ac-filter-search]', section).forEach(function (input) {
      var listbox = input.closest('.ac-coll__filter-body').querySelector('[data-ac-filter-listbox]');
      if (!listbox) return;
      var items = $$('[data-ac-filter-item]', listbox);
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        items.forEach(function (it) {
          var k = it.getAttribute('data-search') || '';
          if (!q || k.indexOf(q) > -1) { it.removeAttribute('hidden'); }
          else { it.setAttribute('hidden', ''); }
        });
      });
    });
  }

  /* ============ AJAX live filter ============ */
  function getFilterFormData(section) {
    var form = $('[data-ac-filter-form]', section);
    if (!form) return null;
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) {
      if (v !== '' && v != null) params.append(k, v);
    });
    return params;
  }

  function setLoading(section, flag) {
    var wrap = $('[data-ac-grid-wrap]', section);
    if (wrap) wrap.classList.toggle('is-loading', !!flag);
    section.classList.toggle('is-loading', !!flag);
  }

  function applyFromUrl(section, params) {
    var url = new URL(window.location.href);
    var basePath = url.pathname;
    var qs = params.toString();
    var newUrl = basePath + (qs ? '?' + qs : '');
    if (history.replaceState) history.replaceState({ acFilters: qs }, '', newUrl);
    fetchAndReplace(section, basePath, qs);
  }

  function fetchAndReplace(section, basePath, qs) {
    var sectionId = getSectionId(section);
    if (!sectionId) return;
    setLoading(section, true);

    var fetchUrl = basePath + '?section_id=' + encodeURIComponent(sectionId) + (qs ? '&' + qs : '');

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Network ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('.ac-coll');
        if (!newSection) {
          // fallback: full reload
          window.location.search = qs;
          return;
        }
        // Replace sidebar + grid + toolbar elements (preserve scroll)
        replacePart(section, newSection, '.ac-coll__sidebar [data-ac-filter-form]');
        replacePart(section, newSection, '[data-ac-grid-wrap]');
        // Update counts everywhere
        updateText(section, newSection, '[data-ac-results-count]');
        updateText(section, newSection, '[data-ac-results-count-mobile]');
        updateText(section, newSection, '[data-ac-results-count-mobile-cta]');
        // Update trigger badge (re-render whole toolbar trigger button)
        replacePart(section, newSection, '[data-ac-filter-open]');
        // Re-init interactions on new DOM
        initFilterSearch(section);
        initAccordion(section);
        initColorGroups(section);
        initPriceRange(section);
        initDrawer(section); // re-bind close button references inside replaced sidebar
        // (open button binding survives because we replaced its content but not the listener; safer to re-add)
      })
      .catch(function (err) {
        console.error('[ac-collection] AJAX failed', err);
        // Fallback: real navigation
        window.location.search = qs;
      })
      .finally(function () {
        setLoading(section, false);
      });
  }

  function replacePart(oldRoot, newRoot, selector) {
    var oldEl = oldRoot.querySelector(selector);
    var newEl = newRoot.querySelector(selector);
    if (oldEl && newEl) oldEl.replaceWith(newEl);
  }
  function updateText(oldRoot, newRoot, selector) {
    var newEls = newRoot.querySelectorAll(selector);
    var oldEls = oldRoot.querySelectorAll(selector);
    var n = Math.min(newEls.length, oldEls.length);
    for (var i = 0; i < n; i++) {
      oldEls[i].textContent = newEls[i].textContent;
    }
  }

  /* ============ Form change handlers ============ */
  function initFormHandlers(section) {
    // Use event delegation so it survives re-render
    section.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;
      // checkbox / number change inside filter form
      if (target.matches('[data-ac-filter-form] input[type="checkbox"]')) {
        var params = getFilterFormData(section);
        if (params) applyFromUrl(section, params);
      }
      // sort select
      if (target.matches('[data-ac-sort]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', target.value);
        // also keep current filters
        var params2 = getFilterFormData(section);
        if (params2) {
          params2.set('sort_by', target.value);
          applyFromUrl(section, params2);
        } else {
          window.location.href = url.toString();
        }
      }
    });

    // Price apply button
    section.addEventListener('click', function (e) {
      var t = e.target;
      if (t.matches('[data-ac-price-apply]') || t.closest('[data-ac-price-apply]')) {
        var params = getFilterFormData(section);
        if (params) applyFromUrl(section, params);
        e.preventDefault();
        return;
      }
      // Clear all
      if (t.matches('[data-ac-clear-all]') || t.closest('[data-ac-clear-all]')) {
        e.preventDefault();
        // Strip all filter params, keep only sort_by
        var current = new URL(window.location.href);
        var keep = new URLSearchParams();
        if (current.searchParams.get('sort_by')) keep.set('sort_by', current.searchParams.get('sort_by'));
        applyFromUrl(section, keep);
        return;
      }
      // Intercept pagination and active chip links
      var link = t.closest('[data-ac-link]');
      if (link && link.tagName === 'A' && link.href) {
        e.preventDefault();
        var lu = new URL(link.href);
        var lparams = new URLSearchParams(lu.search);
        applyFromUrl(section, lparams);
        // scroll to top of grid
        var top = section.querySelector('.ac-coll__toolbar');
        if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    });

    // Allow Enter in price inputs to apply
    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t.matches && t.matches('[data-ac-price]')) {
        e.preventDefault();
        var params = getFilterFormData(section);
        if (params) applyFromUrl(section, params);
      }
    });
  }

  /* ============ Accordion (single open at a time) ============ */
  function initAccordion(section) {
    var accordionFilters = $$('[data-ac-accordion="single"]', section);
    accordionFilters.forEach(function (det) {
      // Use toggle event (fires when <details> open state changes)
      det.addEventListener('toggle', function () {
        if (!det.open) return;
        accordionFilters.forEach(function (other) {
          if (other !== det && other.open) other.open = false;
        });
      });
    });
  }

  /* ============ Color macro groups ============ */
  function initColorGroups(section) {
    $$('[data-ac-color-groups]', section).forEach(function (groupRow) {
      var list = groupRow.parentElement.querySelector('[data-ac-color-list]');
      if (!list) return;
      var buttons = $$('[data-ac-color-group]', groupRow);

      function syncActive() {
        buttons.forEach(function (btn) {
          var keys = (btn.getAttribute('data-ac-color-group') || '').split(',');
          var allChecked = true, anyMatched = false;
          keys.forEach(function (k) {
            var label = list.querySelector('label[data-ac-color-name="' + k.trim() + '"]');
            if (label) {
              anyMatched = true;
              var cb = label.querySelector('input[type="checkbox"]');
              if (!cb || !cb.checked) allChecked = false;
            }
          });
          btn.classList.toggle('is-active', anyMatched && allChecked);
        });
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var keys = (btn.getAttribute('data-ac-color-group') || '').split(',');
          var isActive = btn.classList.contains('is-active');
          var changed = false;
          keys.forEach(function (k) {
            var label = list.querySelector('label[data-ac-color-name="' + k.trim() + '"]');
            if (label) {
              var cb = label.querySelector('input[type="checkbox"]');
              if (cb && !cb.disabled && cb.checked === isActive) {
                cb.checked = !isActive;
                changed = true;
              }
            }
          });
          syncActive();
          if (changed) {
            var params = getFilterFormData(section);
            if (params) applyFromUrl(section, params);
          }
        });
      });

      syncActive();
    });
  }

  /* ============ Dual range price slider ============ */
  function initPriceRange(section) {
    $$('[data-ac-range]', section).forEach(function (range) {
      var minI = range.querySelector('[data-ac-range-min]');
      var maxI = range.querySelector('[data-ac-range-max]');
      var fill = range.querySelector('[data-ac-range-fill]');
      var minOut = range.querySelector('[data-ac-range-min-val]');
      var maxOut = range.querySelector('[data-ac-range-max-val]');
      var minHidden = range.querySelector('[data-ac-range-min-hidden]');
      var maxHidden = range.querySelector('[data-ac-range-max-hidden]');
      if (!minI || !maxI || !fill) return;

      var rangeMax = parseFloat(range.getAttribute('data-range-max')) || 500;
      var minGap = Math.max(1, Math.round(rangeMax * 0.02));

      function paint() {
        var lo = parseFloat(minI.value);
        var hi = parseFloat(maxI.value);
        if (hi - lo < minGap) {
          if (this === minI) lo = hi - minGap;
          else hi = lo + minGap;
          minI.value = lo; maxI.value = hi;
        }
        var loPct = (lo / rangeMax) * 100;
        var hiPct = (hi / rangeMax) * 100;
        fill.style.left = loPct + '%';
        fill.style.right = (100 - hiPct) + '%';
        if (minOut) minOut.textContent = Math.round(lo);
        if (maxOut) maxOut.textContent = Math.round(hi);
      }

      function commit() {
        var lo = parseFloat(minI.value);
        var hi = parseFloat(maxI.value);
        if (minHidden) minHidden.value = (lo > 0) ? String(Math.round(lo)) : '';
        if (maxHidden) maxHidden.value = (hi < rangeMax) ? String(Math.round(hi)) : '';
        var params = getFilterFormData(section);
        if (params) applyFromUrl(section, params);
      }

      minI.addEventListener('input', paint.bind(minI));
      maxI.addEventListener('input', paint.bind(maxI));
      minI.addEventListener('change', commit);
      maxI.addEventListener('change', commit);
      // touch — release fires change
      minI.addEventListener('touchend', commit);
      maxI.addEventListener('touchend', commit);

      paint();
    });
  }

  /* ============ Init ============ */
  function init() {
    var section = getSection();
    if (!section) return;
    initDrawer(section);
    initFilterSearch(section);
    initAccordion(section);
    initColorGroups(section);
    initPriceRange(section);
    initFormHandlers(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
